import { defineComponent, h } from 'vue';

export default defineComponent({
  name: 'Panel',
  setup(_, { slots }) {
    return () => h('div', slots.default?.());
  }
});
